import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'
import { pluralize } from '@fourthwall/utils/dist/string'
import { routing } from '@utils/routing'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'INSTALL_N_OR_MORE_APPS' }>
}

export const AppsIncentive = ({ incentive }: Props) => {
  const { tablet } = useMediaQueryContext()

  return (
    <Incentive
      type={incentive.type}
      icon="🧰"
      label={`Connect ${incentive.amountToInstall} ${pluralize(incentive.amountToInstall, 'social selling app', 'social selling apps')}`}
      isCompleted={incentive.isCompleted}
      bonus={getBonus(incentive.bonus)}
      button={{
        label: tablet ? 'Browse our apps' : 'Browse',
        to: routing.apps.self,
      }}
    />
  )
}
